import { jsx as _jsx } from "react/jsx-runtime";
import { icons } from "./helpers";
import { ExternalIconWrapper, SymbolsWrapper } from "./styles";
export default function IconSelector({ "aria-label": ariaLabel, "data-testid": dataTestid, name, color, size, classType, materialSymbols, flexParams, className, sizeIgnoreHeight, }) {
    const commonProps = {
        "aria-label": ariaLabel,
        "data-testid": dataTestid,
        color: color,
        size,
        sizeIgnoreHeight,
        ...flexParams,
    };
    const { source } = icons[name];
    if (source) {
        const IconVariant = source?.fill?.[JSON.stringify(materialSymbols.fill)] || source.default;
        return (_jsx(ExternalIconWrapper, { ...commonProps, children: _jsx(IconVariant, { className: className }) }));
    }
    return (_jsx(SymbolsWrapper, { className: `${classType} ${className || ""}`, materialSymbols: materialSymbols, ...commonProps, children: name }));
}
//# sourceMappingURL=IconSelector.js.map